// extracted by mini-css-extract-plugin
export default {"root":"jl4RBTun","buttonGroup":"TumomVJq","root__mobile":"hRnIvs_L","faq":"ZmHxyUCR","button":"Z4v9lBHx"};